import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Radio } from '../radio/radio.component.js';
import { Text } from '../text/text.component.js';
import { Fieldset, Container } from './radio-group.style.js';

const RadioGroup = props => {
    const { className = '', color = 'primary', error, highlightSelected, isChecked, isDisabled, margin, name, onChange, options, legend, width = '200px' } = props, rest = __rest(props, ["className", "color", "error", "highlightSelected", "isChecked", "isDisabled", "margin", "name", "onChange", "options", "legend", "width"]);
    const radioButtons = options.map(option => {
        const { value } = option;
        const disabled = isDisabled ? isDisabled(value) : false;
        return (jsx(Radio, Object.assign({ checked: isChecked(value, value), color: color, highlightSelected: highlightSelected, onChange: onChange, disabled: disabled, margin: { bottom: '8px' }, name: name }, option), value));
    });
    const errorMessage = (jsx(Text, Object.assign({ color: "error", textStyle: "paragraph400", margin: { left: '24px' } }, { children: error }), void 0));
    if (legend)
        return (jsxs(Fieldset, Object.assign({ className: className, margin: margin }, rest, { width: width }, { children: [jsx("legend", { children: typeof legend === 'string' ? (jsx(Text, Object.assign({ margin: { bottom: '8px' }, color: color }, { children: legend }), void 0)) : ({ legend }) }, void 0), radioButtons, errorMessage] }), void 0));
    return (jsxs(Container, Object.assign({ className: className, margin: margin }, rest, { width: width }, { children: [radioButtons, errorMessage] }), void 0));
};

export { RadioGroup };
